import React from 'react';
import EntitiesLoader from '../entities/EntitiesLoader/EntitiesLoader';
import { EntityServiceName } from '@api/enums/enums';
//TODO change form
import EvEntityRowForm from '../ev-editor/EvEntityRowForm';
import { ScenarioEventsEntityName } from '@api/types/types';

const getUrlFunc = ({ id }: any) => `./${id}/edit`;

const EmissionsEventsList = () => {
    const serviceName = EntityServiceName.SCENARIO;

    return (
        <EntitiesLoader
            entityName={ScenarioEventsEntityName.EmissionEvent}
            layerEntityName={ScenarioEventsEntityName.EmissionEvent}
            serviceName={serviceName}
            form={EvEntityRowForm}
            // linkable={true}
            getUrlFunc={getUrlFunc}
        />
    );
};

export default EmissionsEventsList;
